import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import Filter from '@/components/Filter';
import TokenCards from '../components/TokenCards';
import TokensPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/TokensPanelContainer';
import TokensFilters from './TokensFilters';

const TokensPanelNarrow = ({
  tokens,
  filterTerm,
  category,
  currentPage,
  pageSize,
  pageCount,
  total,
  fetchData,
  updateFilterTerm,
  readStatus,
  readErrors,
  canRead,
  allowUserLink,
  canCreate,
  newToken,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(tokens, { pageSize, total }));
  return (
    <TokensPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-tokens-panel-narrow">
      <div className="sticky-panel-header">
        <Filter
          error={readStatus === states.ERROR}
          className="aridhia-list-filter"
          filterTerm={filterTerm}
          updateFilter={({ value }) => updateFilterTerm(category, value)}
          onFilter={() => fetchData(category, 1, null, false)}
          label={<TokensFilters category={category} />}
          fluid
        />
      </div>
      <TokenCards
        allowUserLink={allowUserLink}
        canCreate={canCreate}
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={tokens}
        itemsPerRow={1}
        newToken={newToken}
        readErrors={readErrors}
        readStatus={readStatus}
      />
    </TokensPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TokensPanelNarrow);
